import { FC } from 'react';
import { useAppSelector } from '~/app/hooks/hooks';
import { iTableHead } from '~/app/models';
import { formatMoney } from '~/app/utils';
import { Table } from '~/components/common/Table';
import { NoRecord } from '~/components/pages/Err';

const INVOICE_DETAIL: iTableHead[] = [
  { name: 'Product', className: 'py-3 ps-0 fs-14 fw-medium w-35' },
  { name: 'Price', className: 'py-3 fs-14 fw-medium text-end' },
  { name: 'Qty', className: 'py-3 fs-14 fw-medium text-end' },
  { name: 'Subtotal', className: 'py-3 fs-14 fw-medium text-end' },
  { name: 'Tax Amount', className: 'py-3 fs-14 fw-medium text-end' },
  { name: 'Discount', className: 'py-3 fs-14 fw-medium text-end' },
  { name: 'Row Total', className: 'py-3 fs-14 fw-medium text-end' },
];

export const TableInvoice: FC = () => {
  const { status, invoiceDetail, dataDetails } = useAppSelector((state) => state.orderReducer);
  const { currentStore } = useAppSelector((state) => state.authReducer);
  const { items } = invoiceDetail;
  const arr = items.map((item: any) => item.order_item_id);

  const itemWithOutConfigurable = dataDetails.items.filter((item: any) => arr.includes(item.item_id) && item.product_type !== 'configurable');

  const getItemData = (id: number, parent_item?: any) => {
    const item: any = items.find((item: any) => item.order_item_id === id);

    return {
      qty: item?.qty || 0,
      base_row_total: item?.base_row_total || 0,
      price: item?.price_incl_tax || 0,
      discount_amount: item?.discount_amount || 0,
      base_tax_amount: item?.base_tax_amount || 0,
      name: item?.name,
      sku: item?.sku,
      parent_item,
    };
  };

  const convertDeliveryCode = (data: string[]) => {
    if (!data) return undefined;
    const deliveryString = JSON.parse(JSON.stringify(data));

    const result = deliveryString.map((item: any) => JSON.parse(item));

    return result;
  };

  const renderDetails = (item: any) => {
    const { parent_item } = item;
    return item.parent_item ? renderTd(getItemData(item.parent_item.item_id, parent_item)) : renderTd(getItemData(item.item_id));
  };
  const renderTd = (item: any) => {
    const options = convertDeliveryCode(item?.parent_item?.extension_attributes?.deliverycode);

    return (
      <>
        <td className="ps-0 fs-14 vertical-middle">
          <p className="mb-0 fw-medium" dangerouslySetInnerHTML={{ __html: item.name }} />
          <p className="mb-0 sku-product">SKU: {item.sku}</p>
          {options
            ? options.map((option: any, i: number) => {
                return (
                  <p key={i} className="mb-0 option-product">
                    {option.label}: {option.value}
                  </p>
                );
              })
            : ''}
        </td>
        <td className="fs-14 vertical-middle text-end">{formatMoney(item.price, currentStore)}</td>
        <td className="fs-14 vertical-middle text-end">
          <p className="mb-0">{item.qty}</p>
        </td>
        <td className="fs-14 vertical-middle text-end">{formatMoney(item.price * item.qty, currentStore)}</td>
        <td className="fs-14 vertical-middle text-end">{formatMoney(+item.base_tax_amount || 0, currentStore)}</td>
        <td className="fs-14 vertical-middle text-end">{formatMoney(item.discount_amount ? item.discount_amount : 0, currentStore)}</td>
        <td className="fs-14 vertical-middle text-end">{formatMoney(item.price * item.qty - item.discount_amount, currentStore)}</td>
      </>
    );
  };

  return (
    <div className="info-table bg-white p-4 pb-0 wrapper">
      <p className="title pb-4 fs-16 m-0 fw-medium text-uppercase">Items Invoiced</p>
      <Table status={status} dataTableHead={INVOICE_DETAIL} className=" ">
        {itemWithOutConfigurable.length ? (
          itemWithOutConfigurable.map((item: any, i: number) => {
            return <tr key={i}>{renderDetails(item)}</tr>;
          })
        ) : (
          <NoRecord tableHeaders={INVOICE_DETAIL} />
        )}
      </Table>
    </div>
  );
};
